(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["linde-announcement-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    let btn = document.querySelector('.item__title')
    btn.addEventListener('click', ()=> {
      let expanded = btn.getAttribute('aria-expanded')
      let div = document.querySelector('.item__links')
      div.classList.toggle('open')
      expanded == 'true'? btn.setAttribute("aria-expanded", "false") : btn.setAttribute("aria-expanded", "true")

    })
  });
  } catch(e) { console.error(e); }
})();

})();
